var exports = {
  "k": "x61f99309--e7287e--container",
};

module.exports = exports;
